import posthog from "posthog-js";

import { getClient } from "./browser"

export function trackAction(name: string, properties: Record<string, string | number>) {
    console.log('--------')
    console.log({name, properties})
    const client = getClient()
    posthog.capture(name, {...properties, client})
}

/**
 * Parameters for setting subscription information
 */
export interface SubscriptionInfoParams {
  /** Whether the user has a paid subscription */
  isPaid: boolean;
  /** The subscription plan name (optional) */
  plan?: string;
}

/**
 * Sets the subscription information in the user properties
 * @param params - Object containing subscription parameters
 */
export function setSubscriptionInfo(params: SubscriptionInfoParams) {
    const { isPaid, plan } = params;
    
    // Create property values
    const subscriptionStatus = isPaid ? 'paid' : 'free';
    const subscriptionPlan = plan || (isPaid ? 'paid' : 'free');
    
    // Use the recommended $set event approach
    posthog.capture('$set', {
        $set: {
            subscription_status: subscriptionStatus,
            subscription_plan: subscriptionPlan
        }
    });
    
    // Log the subscription status update
    console.log('Updated subscription info:', {
        subscription_status: subscriptionStatus,
        subscription_plan: subscriptionPlan
    });
}

/**
 * Parameters for identifying a user
 */
export interface IdentifyUserParams {
  /** The user's ID from Supabase */
  userId: string;
  /** Additional user properties to set */
  userProperties?: Record<string, any>;
}

/**
 * Identifies a user in PostHog when they log in with Supabase
 * @param params - Object containing identification parameters
 */
export function identifyUser(params: IdentifyUserParams) {
    const { userId, userProperties } = params;
    
    console.log('🔍 [Monitoring] IDENTIFY USER CALLED', {
        userId,
        hasProperties: !!userProperties,
        propertyCount: userProperties ? Object.keys(userProperties).length : 0,
        isPosthogAvailable: !!posthog,
        isPosthogInitialized: !!(posthog && posthog.get_distinct_id),
        timestamp: new Date().toISOString()
    });
    
    // Check if PostHog is available
    if (!posthog) {
        console.error('❌ [Monitoring] CRITICAL: Failed to identify - PostHog is not initialized', {
            userId,
            error: 'PostHog not initialized',
            timestamp: new Date().toISOString()
        });
        return;
    }

    try {
        // Log the identification attempt
        console.log('⏳ [Monitoring] ATTEMPTING IDENTIFY:', {
            userId,
            distinctId: posthog.get_distinct_id(),
            hasProperties: !!userProperties,
            propertyCount: userProperties ? Object.keys(userProperties).length : 0,
            timestamp: new Date().toISOString()
        });
        
        // Set the distinct ID for this user and set properties in a single call
        posthog.identify(userId, userProperties || {});
        
        // Log successful identification
        console.log('✅ [Monitoring] IDENTIFY SUCCESS:', {
            userId,
            distinctId: posthog.get_distinct_id(),
            timestamp: new Date().toISOString()
        });
        
        // Track the login event
        trackAction('User Logged In', { userId });
    } catch (error) {
        console.error('❌ [Monitoring] IDENTIFY FAILED:', {
            userId,
            error: error instanceof Error ? error.message : 'Unknown error',
            errorObject: error,
            timestamp: new Date().toISOString()
        });
    }
}

